import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Input from '../InputNumber';
import InputUnit from '../InputUnit';
import InputNumberUnitLayout from '../InputNumberUnitLayout';
import './styles.css';

class InputNumberUnit extends Component {
	render() {
		const { unit, variable, active, min, max, step } = this.props;
		return (
			<InputNumberUnitLayout>
				<InputUnit unit={unit} />
				<Input variable={variable} active={active} min={min} max={max} step={step} />
			</InputNumberUnitLayout>
		);
	}
}

InputNumberUnit.propTypes = {
	unit: PropTypes.string,
	variable: PropTypes.object,
	active: PropTypes.bool
};
export default InputNumberUnit;
